import React from "react";

export default function FlatIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.95526 2.25C6.52244 2.24995 6.12561 2.24991 5.8028 2.29331C5.44732 2.3411 5.07159 2.45355 4.76257 2.76257C4.45355 3.07159 4.3411 3.44732 4.29331 3.8028C4.24991 4.12561 4.24995 4.52244 4.25 4.95526L4.25001 21C4.25001 21.4142 4.58579 21.75 5.00001 21.75C5.41422 21.75 5.75001 21.4142 5.75001 21L5.75001 14.75H17.1979C18.6074 14.75 19.75 13.6074 19.75 12.1979C19.75 11.3576 19.3363 10.571 18.6438 10.0949L18.3625 9.90159C17.3795 9.22575 17.3795 7.77426 18.3625 7.09842L18.6438 6.90507C19.3363 6.42897 19.75 5.64245 19.75 4.80207C19.75 3.3926 18.6074 2.25001 17.1979 2.25001L6.95526 2.25Z"
        fill="#A6B0CF"
      />
    </svg>
  );
}
